export class AudioPlayer {

    /**
     * Create an audio manager.
     * @param {string} id - The ID of the audio element.
     */
    constructor(id) {

        this.audioElement = this.createAudioElement(id)
        this.hasPlayed = false

    }

    /**
     * @param {string} id - The ID of the audio element.
     */
    createAudioElement(id) {

        const audioElement = document.createElement('audio')

        audioElement.id = id

        const audioContainer = document.getElementById('audio_players')

        audioContainer.appendChild(audioElement)

        return audioElement

    }

    /**
     * Load an audio file.
     * @param {string} audioUrl - The URL of the audio file.
     * @param loop
     */
    autoplay(audioUrl, loop = false) {

        if (audioUrl === undefined || audioUrl === null) {

            this.audio = null

            return

        }

        this.loadAudio(audioUrl)
        this.registerListeners()
        this.audioElement.loop = loop
        this.play()

    }

    /**
     * Load an audio file.
     * @param {string} audioUrl - The URL of the audio file.
     */
    loadAudio(audioUrl) {

        this.audioElement.src = audioUrl
        this.hasPlayed = false
        this.audioElement.load()

    }

    /**
     * Play the audio.
     */
    play() {

        if (this.hasPlayed) {
            return
        }

        if (this.isPlaying()) {
            return
        }

        const promise = this.audioElement.play()

        promise
            .then(
                () => {

                    this.destroyListeners()
                    this.hasPlayed = true

                },
            ).catch(() => {
                console.log('Audio playback was prevented by the browser')
            })

    }

    /**
     * Pause the audio.
     */
    async pause() {

        if (this.isPlaying()) {
            await this.audioElement.pause()
        }

    }

    /**
     * Stop the audio.
     */
    async stop() {

        await this.pause()
        this.audioElement.currentTime = 0

    }

    /**
     * Check if the audio is currently playing.
     * @returns {boolean} - True if the audio is playing, false otherwise.
     */
    isPlaying() {
        return !this.audioElement.paused && this.audioElement.currentTime > 0
    }

    registerListeners() {

        document.addEventListener('click', () => this.play())
        document.addEventListener('scroll', () => this.play())
        document.addEventListener('keydown', () => this.play())
        document.addEventListener('touchstart', () => this.play())
        document.addEventListener('touchend', () => this.play())

    }

    destroyListeners() {

        document.removeEventListener('click', () => this.play())
        document.removeEventListener('scroll', () => this.play())
        document.removeEventListener('keydown', () => this.play())
        document.removeEventListener('touchstart', () => this.play())
        document.removeEventListener('touchend', () => this.play())

    }

}
